import React, { Component } from 'react';
import firebase from './Config/Firebase'
import { Route, Redirect, Link } from 'react-router-dom';
import history from './Config/history'
import { BrowserRouter as Router } from 'react-router-dom'
import './App.css';
import Login from './Component/Login'
import Homepage from './Component/Homepage'
import Groups from './Component/Home/Groups'
import AddGroup from './Component/Home/Add Group'
import Clues from './Component/Home/Clues'






class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      login: false,
      again: false,

    }
  }

  login = () => {
    this.setState({ login: true })
  }



  componentWillMount() {
    this.authListener();

  }

  authListener = () => {

    var s = localStorage.getItem("User");
    if (s != null) {
      this.setState({ login: true })
    }
    else {
      this.setState({ login: false })
    }

  }

  logout = () => {
    firebase.auth().signOut();
    localStorage.removeItem("User")
    this.setState({ login: false })

  }

  timedout = () => {
    //console.log("timeotu")
    localStorage.removeItem("User")
    this.setState({ again: true, login: false })

  }

  again = () => {
    this.setState({ again: false })
  }


  render() {
    return (
      <div className="App">
        <Router history={history}>
          {this.state.login && <Redirect to="/homepage" push={true} />}
          <div>

            <Route exact path="/" component={() => <Login login={this.login} again={this.again} stateagain={this.state.again} />} />
            <Route exact path="/homepage" strict render={() => (this.state.login ? (<Homepage logout={this.logout} timedout={() => { this.timedout() }} />) : (<Redirect to="/" />))} />






          </div>
        </Router>
      </div>
    );
  }
}

export default App;
